import React from "react";
import { Skeleton, Space } from "antd";
import "./LoadingOverlay.css";

const LoadingOverlay = ({
  rows = 3,
  showHeader = true,
  variant = "default",
  marginLeft,
}) => {
  return (
    <div
      className="loading-overlay"
      style={{
        marginLeft: marginLeft,
        width: `calc(100vw - ${marginLeft}px - 36px`,
        maxHeight: `calc(100vh - 56px)`,
      }}
    >
      <div
        className="loading-overlay-wrapper"
        style={{
          width: `calc(100vw - ${marginLeft}px - 36px`,
        }}
      >
        {variant === "default" && (
          <>
            {/* Page Header */}
            <div className="skeleton-page-header">
              <div className="skeleton-header-content">
                <Skeleton.Input
                  active
                  size="large"
                  style={{ width: 300, height: 40 }}
                />
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: 500, height: 20, marginTop: 12 }}
                />
              </div>
              <Space style={{ marginTop: 16 }}>
                <Skeleton.Button active size="large" style={{ width: 120 }} />
                <Skeleton.Button active size="large" style={{ width: 100 }} />
              </Space>
            </div>

            {/* Stats/Metrics Section */}
            <div className="skeleton-stats-section">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="skeleton-stat-card">
                  <Skeleton.Input
                    active
                    size="small"
                    style={{ width: "80%", height: 16 }}
                  />
                  <Skeleton.Input
                    active
                    size="large"
                    style={{ width: "60%", height: 32, marginTop: 12 }}
                  />
                </div>
              ))}
            </div>

            {/* Additional Content Section */}
            <div className="skeleton-content-section">
              <Skeleton
                active
                title={{ width: "30%" }}
                paragraph={{ rows: 2, width: ["100%", "90%"] }}
              />
            </div>

            {/* Table/List Section */}
            <div className="skeleton-table-section">
              <Skeleton.Input
                active
                size="default"
                style={{ width: 200, height: 24, marginBottom: 16 }}
              />
              <Skeleton active paragraph={{ rows: rows + 2 }} />
            </div>
          </>
        )}

        {variant === "card" && (
          <div className="skeleton-cards">
            {[...Array(rows)].map((_, index) => (
              <Skeleton.Node
                key={index}
                active
                style={{ width: "100%", height: "300px" }}
              >
                <Skeleton
                  active
                  avatar={false}
                  title={showHeader}
                  paragraph={{ rows: 3 }}
                />
              </Skeleton.Node>
            ))}
          </div>
        )}

        {variant === "table" && (
          <div className="skeleton-table-wrapper">
            <Skeleton active title={showHeader} paragraph={{ rows: rows }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
